import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { MetricsService } from 'src/app/main/metrics/services/metrics.service';
import { LoginMetric } from 'src/app/main/metrics/models/login-metric.model';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public barChartOptions: ChartOptions = {
    responsive: true,
  };

  public barChartLabels: Label[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataSets[] = [];

  public mesList = [
    {id: 1, name: 'JAN'},
    {id: 2, name: 'FEV'},
    {id: 3, name: 'MAR'},
    {id: 4, name: 'ABR'},
    {id: 5, name: 'MAI'},
    {id: 6, name: 'JUN'},
    {id: 7, name: 'JUL'},
    {id: 8, name: 'AGO'},
    {id: 9, name: 'SET'},
    {id: 10, name: 'OUT'},
    {id: 11, name: 'NOV'},
    {id: 12, name: 'DEZ'},
  ];

  public anoList = [
    {id: 2023, name: '2023'},
    {id: 2024, name: '2024'},
    {id: 2025, name: '2025'},
    {id: 2026, name: '2026'},
    {id: 2027, name: '2027'},
    {id: 2028, name: '2028'},
  ];

  formGroup: FormGroup;
  showChart = false;

  constructor(
      private metricsService: MetricsService,
      private formBuilder: FormBuilder,
      private layoutService: LayoutService,
  ) {}

  ngOnInit(): void {
    this.buildFormFilter();
  }

  submitFilter(): void {
    if (this.formGroup.get('mes').value && this.formGroup.get('ano').value) {
      this.buildBarChart(this.formGroup.get('mes').value, this.formGroup.get('ano').value);
    }
  }

  restartDefaultValues(): void {
    this.showChart = false;
    this.barChartLabels = [];
    this.barChartType = 'bar';
    this.barChartLegend = true;
    this.barChartPlugins = [];
    this.barChartData = [];
  }

  private buildFormFilter(): void {
    this.formGroup = this.formBuilder.group({
      mes: [],
      ano: [],
    });
  }

  private buildBarChart(month: number, year: number): void {
    this.restartDefaultValues();
    this.layoutService.loading();

    this.metricsService.getLogins(month, year)
        .subscribe((data: Array<LoginMetric>) => {

          this.barChartLabels.push(data.length ? data[0].mesNome : null);

          data.forEach(i => {
            this.barChartData.push({ data: [i.total], label: i.email.toString().toLowerCase(), backgroundColor: this.randomColor() });
          });

        })
        .add(() => {
          if (this.barChartData.length > 0) {
            this.showChart = true;
          }
          this.layoutService.loaded();
        });
  }

  private randomColor(): string {
    return '#' + (0x1000000 + Math.random() * 0xffffff).toString(16).substr(1, 6);
  }

}
